import Table from "@/components/Table/table";
import { useColumnHistoryDefs } from "@/features/creditor/claimsTab/Constant/AttributeHistoryClaims";
import { useParams } from "react-router-dom";
import { useGetCreditorAttributeHistoryDataQuery } from "../CreditorSummaryUpdate/CreditorSummaryReducer";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { useCase } from "@/features/case/use-case";
import { useTranslation } from "react-i18next";
import CustomPagination from "@/components/Pagination/CustomPagination";
import {
  customPaginationPageSizeSelector,
  customTableLoadingData,
} from "@/components/Table/CustomPaginationConstants";
import { useDispatch, useSelector } from "react-redux";
import {
  setComponentState1,
} from "@/features/retain_state/retainStateSlice";
import { useMemo } from "react";

export const TitleComplement = () => {
  return <></>;
};

export default function CreditorAttributeHistoryTab() {
  const { creditorId } = useParams<{
    creditorId: string;
  }>();
  const { t } = useTranslation();
  const retainState = useSelector(
    (e: any) => e.retainState.creditorAttributeHisTabState
  );
  const dispatch = useDispatch();
  const getPaginationObj: any =useMemo(() => {
    let value: any = {
      creditorId: creditorId,
      PageNumber: retainState?.PageNumber || 1,
      PageSize: retainState?.PageSize,
      SearchText: retainState?.SearchText || "",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  },[creditorId, retainState]);
  const paginationObj = getPaginationObj
  function handlePaginationData(data: any, columnTypesData: any) {
    dispatch(
      setComponentState1({
        entityName: "creditorAttributeHisTabState",
        entityState: {
          SortOrder: data.SortOrder,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }

  const { data, isLoading, isFetching, isError,status } =
    useGetCreditorAttributeHistoryDataQuery(paginationObj);
  const headerData = {
    title: "Attribute History X",
    description: "Descriptive text that describes your page or content.",
  };
  const caseData = useCase();
  const timeZone = caseData?.abbreviation;
  const columnHistoryDefs = useColumnHistoryDefs(timeZone);

  return (
    <>
      {isLoading ? (
        <MotifProgressLoader show variant="default" className="mar-b-20" />
      ) : (
        <div className="mar-b-20">
          <Table
            columnTypes={{ ...retainState.sortedColumnTypes }}
            handlePaginationData={handlePaginationData}
            paginationObj={paginationObj}
            columnDefs={columnHistoryDefs}
            TitleComplement={TitleComplement}
            title={"pages.creditors.creditorAttributeTab.tableTitle"}
            description={
              "pages.creditors.creditorAttributeTab.tableDescription"
            }
            cellRenderers={isFetching || isError ? [] : data?.results}
            caseRenderers={headerData}
            pagination={false}
            overlayNoRowsTemplate={
              isFetching
                ? t(customTableLoadingData)
                : isError
                ? t("global.globalNotifications.wentWrong")
                : t("global.globalNotifications.noRecords")
            }
          />
          <CustomPagination
           apiData={data}
           apiStatus={status}
            currentpage={paginationObj.PageNumber}
            pageSize={paginationObj.PageSize}
            disableNext={!data?.hasMoreRecords}
            onChangePageSize={(page: number) => {
              dispatch(setComponentState1({
                entityName: "creditorAttributeHisTabState",
                entityState: {
                  PageSize: page,
                  PageNumber: 1,
                },
              }));
            }}
            onChangeNextPage={() => {
              dispatch(setComponentState1({
                entityName: "creditorAttributeHisTabState",
                entityState: {
                  PageNumber: paginationObj.PageNumber + 1,
                },
              }));
            }}
            onChangePreviousPage={() => {
              dispatch(setComponentState1({
                entityName: "creditorAttributeHisTabState",
                entityState: {
                  PageNumber: paginationObj.PageNumber - 1,
                },
              }));
            }}
            pageSizeSelector={customPaginationPageSizeSelector}
          />
        </div>
      )}
    </>
  );
}
